import { I18nPluralPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { BaseStoreFacade, BaseStoreShopsFacade } from '@city/data-access';
import {
  BreadcrumbMeta,
  CanonicalPageResolver,
  Page,
  PageBreadcrumbResolver,
  PageDescriptionResolver,
  PageMetaResolver,
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
  PageType,
  PageTypeResolver,
} from '@spartacus/core';
import { Observable, combineLatest, map } from 'rxjs';
import { CustomBasePageMetaResolver } from './custom-base-page-meta.resolver';

@Injectable({
  providedIn: 'root',
  deps: [I18nPluralPipe],
})
export class ShopsPageMetaResolver
  extends PageMetaResolver
  implements
    PageTitleResolver,
    PageBreadcrumbResolver,
    PageDescriptionResolver,
    PageRobotsResolver,
    CanonicalPageResolver,
    PageTypeResolver
{
  countShops$: Observable<number>;
  currentCity$: Observable<string>;
  shopTitle$: Observable<string>;

  constructor(
    private basePageMetaResolver: CustomBasePageMetaResolver,
    private baseStoreShopsFacade: BaseStoreShopsFacade,
    private i18n: I18nPluralPipe,
    private baseStoreFacade: BaseStoreFacade,
  ) {
    super();
    this.pageType = PageType.CONTENT_PAGE;
    this.countShops$ = this.baseStoreShopsFacade.activeBaseStoreShops$.pipe(map((res) => res.length));
    this.currentCity$ = this.baseStoreFacade.getActiveBaseStore().pipe(map((res) => res.namePrepositional));
    this.shopTitle$ = this.countShops$.pipe(
      map((count) => this.i18n.transform(count, { one: 'магазин', few: 'магазина', many: 'магазинов' })),
    );
  }

  resolveTitle(): Observable<string | undefined> {
    return combineLatest([this.shopTitle$, this.countShops$, this.currentCity$]).pipe(
      map(([title, shopsCount, currentCity]) => `${shopsCount} ${title} в ${currentCity}`),
    );
  }

  resolveDescription(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveDescription();
  }

  resolveBreadcrumbs(): Observable<BreadcrumbMeta[] | undefined> {
    return this.basePageMetaResolver.resolveBreadcrumbs();
  }

  resolveRobots(): Observable<PageRobotsMeta[]> {
    return this.basePageMetaResolver.resolveRobots();
  }

  resolveCanonicalUrl(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveCanonicalUrl();
  }

  resolveType(): Observable<string> {
    return this.basePageMetaResolver.resolveType();
  }

  getScore(page: Page): number {
    return page.pageId === 'contacts' ? 3 : 0;
  }
}
